module.exports = __webpack_public_path__ + "overlook-studios/img/beat-bash-ld47.png";